import Vue from 'vue'
import App from './App'
import VeeValidate from 'vee-validate';
import axios from 'axios'
import VueNoty from 'vuejs-noty'
import VueRouter from 'vue-router'
import Routes from './routes'
import VuejsDialog from "vuejs-dialog"

// import 'bulma/css/bulma.css'
import Vuex from 'vuex';
import 'vuejs-noty/dist/vuejs-noty.css'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
Vue.use(VueRouter)
Vue.use(Vuetify)
Vue.use(VuejsDialog)
Vue.config.productionTip = false
window.axios = axios;
axios.defaults.baseURL = `http://reg.ieeeypegypt.org/api/`
Vue.use(VueNoty, {
  timeout: 10000,
  progressBar: true,
  layout: 'bottomRight',
  theme : 'sunset',
})
const router = new VueRouter({
  routes : Routes,
  mode : 'history'
});

router.beforeEach((to, from, next) => {
  document.title = 'MIE 2021 Registration';
  next()
})

Vue.use(VeeValidate);
new Vue({
  el: '#app',
  components: { App },
  template: '<App/>',
  router
})




// WEBPACK FOOTER //
// ./src/main.js